<ion-content>
    <div class="background-image">
        <div class="logo"></div>

        <h1>Start moving now</h1>

        <section id="country-selection" class="visible">
            <h2>Choose your country</h2>

            <div class="custom-select">
                <div class="select-wrapper">
                    <select
                        [(ngModel)]="countryCode"
                        (change)="onCountryChange()"
                    >
                        <option
                            *ngFor="let country of countryList"
                            value="{{ country.code }}"
                        >
                            {{ country.name }}
                        </option>
                    </select>
                </div>
            </div>
        </section>

        <p class="error" *ngIf="showingNoAccountError">
            Sorry, it looks like you don't have an account but you can
            <a routerLink="/registration/{{ countryCode }}">register</a> for one
            instead.
        </p>

        <section
            id="signin-options"
            [class.visible]="countryCode"
            [class.disabled]="attemptingSignIn"
        >
            <h2>Are you an Adult?</h2>

            <ion-button id="sign-up" (click)="onSignUp()">Register</ion-button>
            <ion-button id="sign-in" fill="outline" (click)="onLogin()">
                Sign In
            </ion-button>
        </section>

        <section
            id="student-options"
            [class.visible]="countryCode"
            *ngIf="supportsMagicCode"
        >
            <h2>Are you a Student?</h2>
            <ion-button id="student-sign-up" (click)="onStudentSignUp()">
                Student Register
            </ion-button>
            <ion-button
                id="student-sign-in"
                fill="outline"
                (click)="onStudentLogin()"
            >
                Student Sign In
            </ion-button>
        </section>

        <section [class.visible]="countryCode" *ngIf="hasSocialSignIns">
            <h2>Or continue with:</h2>

            <div id="google-sign-in" *ngIf="isGoogleSignIsSupported"></div>
            <ion-button
                id="sign-in-demo"
                fill="outline"
                (click)="onDemoSSO()"
                *ngIf="hasOAuthDemo"
            >
                Demo Sign In
            </ion-button>
        </section>

        <p class="version">Version {{ version }}</p>
    </div>
</ion-content>
